import { Row, Col } from "react-bootstrap";
import UserTile from "./UserTile";

const UserUnlockCard = ({userUnlockReward}) => {
  return (
    <Row className="user-unlock-card">
      <Row className="text-start mb-4">
        <Col>
          <span className="fanstore-text">Unlocked</span>
        </Col>
      </Row>
      <Col className="user-tile-container">
        {userUnlockReward?.length > 0 ? userUnlockReward?.map((user) => (
          <UserTile key={user._id} userUnlockReward={user} />
        )) : <h5 className="text-center">No user unlocked this reward</h5>}
      </Col>
    </Row>
  );
};

export default UserUnlockCard;
